import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import Footer from './components/Footer';
import EventsPage from './pages/EventsPage';
import PoliciesPage from './pages/PoliciesPage';
import EventAnalysisDetailPage from './pages/EventAnalysisDetailPage';
import PolicyViolationsDetailPage from './pages/PolicyViolationsDetailPage';
import ComplianceDetailPage from './pages/ComplianceDetailPage';
import NodeDetailPage from './pages/NodeDetailPage';
import PolicyDetailPage from './pages/PolicyDetailPage';
import SecurityControlsDetailPage from './pages/SecurityControlsDetailPage';
import AgentStatusPage from './pages/AgentStatusPage';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="app">
      <Navigation />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/policies" element={<PoliciesPage />} />
        <Route path="/analysis/events" element={<EventAnalysisDetailPage />} />
        <Route path="/analysis/policy-violations" element={<PolicyViolationsDetailPage />} />
        <Route path="/analysis/compliance" element={<ComplianceDetailPage />} />
        <Route path="/analysis/nodes" element={<NodeDetailPage />} />
        <Route path="/analysis/policies" element={<PolicyDetailPage />} />
        <Route path="/analysis/security-controls" element={<SecurityControlsDetailPage />} />
        <Route path="/analysis/agent-status" element={<AgentStatusPage />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;

